import { computed, defineComponent, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ActivityGetter } from '@/store/activity/activity.module';
import { Activity } from '@/store/activity/activity.model';

export default defineComponent({
  name: 'ActivityDispatchPage',
  setup: () => {
    const route = useRoute();
    const router = useRouter();
    const activityId = computed<number>(() => parseInt(route.params.activityId as string));
    const store = useStore();
    const activity = computed<Activity | undefined>(() => store.getters[ActivityGetter.BY_ID](activityId.value));

    onMounted(() => {
      router.push(`/activity/${activityId.value}/province/${activity.value?.provinces[0].id}`);
    });
  },
});
